import {ReactNode} from 'react';
import {twMerge} from '../../../common/twMerge';
import {Grid} from '../../../design-system/atoms/Grid/Grid';
import {DayOfWeekSectionCardBannerItem} from './DayOfWeekSectionCardBannerItem';
import {DayOfWeekSectionCardItem} from './DayOfWeekSectionCardItem';

interface Props {
  className?: string;
  listElement?: ReactNode;
  bannerElement?: ReactNode;
}

export const DayOfWeekSectionColumnList = ({
  listElement,
  bannerElement,
  className,
}: Props) => {
  return (
    <div
      className={twMerge(
        'w-full bg-static-mono-90 p-2pxr rounded-b-10pxr',
        className
      )}
    >
      <Grid cols={1} foldableCols={2} gapPx={2} showEmptyGridItem={true}>
        {listElement}
      </Grid>
      {bannerElement}
    </div>
  );
};

DayOfWeekSectionColumnList.Item = DayOfWeekSectionCardItem;
DayOfWeekSectionColumnList.BannerItem = DayOfWeekSectionCardBannerItem;
